import { render, staticRenderFns } from "./MoveUpIcon.vue?vue&type=template&id=c7e58c44"
import script from "./MoveUpIcon.vue?vue&type=script&lang=js"
export * from "./MoveUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports